module.exports = __webpack_public_path__ + "static/pic21-b3f73183959a68b4e20e2c790f29e8f2.png";